import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import { useAppSelector } from 'hooks/redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import nothingToShowImage from 'assets/img/nocomments.png';
import accountsService from 'services/accounts';
import { removeURLParameter } from 'utils';

interface Params {
  courseHash: string;
  lessonId: string;
}

const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.neutrals.black,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 105px)',
  },
  imgWrapper: {
    width: 400,
    height: 350,
    marginTop: theme.spacing(10),
    position: 'relative',
    '@media (max-width: 640px)': {
      transform: 'scale(0.7)',
      marginBottom: theme.spacing(-5),
      marginTop: theme.spacing(-5),
    },
  },
  waitingContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(0, 6),
    '& b': {
      fontWeight: '700 !important',
    },
    '& p, h1': {
      color: theme.palette.common.white,
    },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(4, 0),
    '& button:first-child': {
      marginRight: theme.spacing(4),
    },
  },
}));

const Content = () => {
  const classes = useStyles();
  const { courseHash, lessonId } = useParams<Params>();
  const isAuthenticated = useAppSelector((store) => store.auth.isAuthenticated);
  const user = useAppSelector((store) => store.user);
  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get('access_id');

  const requestLogout = () => {
    const { pathname, search } = window.location;
    accountsService.logout(pathname + search);
  };

  const redirectToContent = () => {
    const { search, origin } = window.location;
    const params = removeURLParameter(search, 'access_id');
    if (lessonId) {
      return (window.location.href = origin + '/curso/' + courseHash + '/aula/' + lessonId + params);
    }
    return (window.location.href = origin + '/curso/' + courseHash + params);
  };

  useEffect(() => {
    if (!isAuthenticated) {
      accountsService.login();
    }
  }, [isAuthenticated]);

  if ((isAuthenticated && String(user.id) === userId) || !userId) {
    redirectToContent();
    return null;
  }

  if (!isAuthenticated) {
    return (
      <div className={classes.container}>
        <div className={classes.waitingContainer}>
          <div className={classes.imgWrapper}>
            <img src={nothingToShowImage} alt='Vitrine vazia' />
          </div>
          <Typography variant='body2'>Você será redirecionado para a tela de login</Typography>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.waitingContainer}>
        <div className={classes.imgWrapper}>
          <img src={nothingToShowImage} alt='Vitrine vazia' />
        </div>
        <Typography variant='body1'>Esse conteúdo não pertence ao usuário logado.</Typography>
        <Box marginTop={1}>
          <Typography variant='body1'>{user && user?.email}</Typography>
        </Box>
        <Box marginTop={1}>
          <Typography variant='body1'>Por favor troque de usuário e tente novamente.</Typography>
        </Box>
        <div className={classes.buttons}>
          <Button variant='contained' color='primary' onClick={requestLogout}>
            Trocar de usuário
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Content;
